import { Link } from "react-router-dom";
import { useSite } from "@/hooks/useSite";
import { mediaUrl } from "@/lib/api";

export const Logo = ({ dark = false, testId = "site-logo" }) => {
  const url = useSite().data?.settings?.logo_url;
  if (url) return (
    <Link to="/" data-testid={testId} className={dark ? "inline-flex items-center w-fit max-w-[180px] md:max-w-[220px] bg-white rounded-none px-2.5 py-1.5" : "flex items-center"} aria-label="Paisapaid Loans home">
      <img src={mediaUrl(url)} alt="Paisapaid Loans" className={`h-10 w-auto object-contain ${dark ? "max-w-full" : "max-w-[180px]"}`} />
    </Link>
  );
  return (
  <Link to="/" data-testid={testId} className="flex items-center gap-2.5" aria-label="Paisapaid Loans home">
    <svg width="38" height="38" viewBox="0 0 40 40" aria-hidden="true">
      <rect width="40" height="40" rx="11" fill={dark ? "#fff" : "var(--pp-primary)"} />
      <path d="M12 30V10h9.5a6.5 6.5 0 0 1 0 13H17v7h-5zm5-11.5h4a2 2 0 0 0 0-4h-4v4z" fill={dark ? "var(--pp-primary)" : "#fff"} />
      <circle cx="29" cy="28" r="5" fill="var(--pp-cta)" />
    </svg>
    <span className="leading-none">
      <span className={`block text-[19px] font-extrabold tracking-[-0.6px] ${dark ? "text-white" : "text-[var(--pp-text)]"}`}>Paisapaid</span>
      <span className={`block text-[11px] font-bold tracking-[0.28em] uppercase ${dark ? "text-[var(--pp-cta)]" : "text-[var(--pp-link)]"}`}>Loans</span>
    </span>
  </Link>
);
};
